module.exports = __webpack_public_path__ + "img/6.48299e4b.jpg";